import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  anchorTagStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.14), 0px 2px 2px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
    borderRadius: theme.spacing(0.5),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  evLogoForSupportLink: {
    marginRight: theme.spacing(0.5),
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}));
